import { z } from 'zod';

export const cmsDealSchema = z.object({
    id: z.string(),
    code: z.string(),
    priority: z.number(),
    type: z.string(),
    validFrom: z.coerce.date().optional(),
    validTo: z.coerce.date().optional(),
    regions: z.array(z.string()),
    tags: z.array(z.string()).optional(),
    title: z.string().optional().default(''),
    summary: z.string().optional(),
    availableCount: z.number().optional(),
    marketingUrl: z.string().nullable().optional(),
    imgUrl: z.string().nullable().optional(),
    conditions: z
        .object({
            startLocationAt: z.array(z.string()).optional(),
            endLocationAt: z.array(z.string()).optional(),
            productCodeOneOf: z.array(z.string()).optional(),
            maxHireDays: z.number().optional(),
            minHireDays: z.number().optional(),
        })
        .optional(),
    actions: z.object({}),
    visible: z.boolean(),
    marketingStartDate: z.coerce.date().optional(),
    marketingEndDate: z.coerce.date().optional(),
    status: z.string(),
});

export type CmsDeal = z.infer<typeof cmsDealSchema>;
